import React, { Component} from 'react'
import { connect } from 'react-redux'
import {addPassword} from '../../../actions/user'
import {hideModal} from '../../../actions/modals'
import AddPasswordToGoogleForm from '../../../components/forms/account/AddPasswordToGoogleForm'
import AddPasswordToAppleForm from '../../../components/forms/account/AddPasswordToAppleForm'
import errorMessages from '../../../staticData/errorMessages.js'
import {showNotification} from '../../../actions/notifications'

 

const responseGoogle = (response) => {}


class AddPasswordContainer extends Component {

	constructor(){
		super()
		this.addPasswordToGoogle=this.addPasswordToGoogle.bind(this) 
		this.addPasswordToApple=this.addPasswordToApple.bind(this)
	}

	addPasswordToGoogle(googleUser){
		const authInstance=window.gapi.auth2.getAuthInstance()
		authInstance.signOut()
		//const email=this.props.form.values.email
		const newPassword=this.props.form.values.newPassword
		// const recaptchaResponse=this.props.form.values.recaptchaResponse
		const requestData={
			idToken:googleUser.tokenId,
			password:newPassword
		}


		this.props.addPassword(this.props.user.id,requestData).then((response) => {
			this.props.hideModal()
			const notificationMessage='email and password login to your account'
		 	this.props.showNotification(notificationMessage,'Added','default')
		})
			.catch(error => {
				this.props.hideModal()
				let errorMessage='Something went wrong. Unable to add email and password login.'
				if(errorMessages.accountErrors.addPassword[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.addPassword[error.response.status]}`
				}
				this.props.showNotification(errorMessage,'Error','destroy')
			})
	}

	addPasswordToApple(data){
		const newPassword=this.props.form.values.newPassword
		const requestData={
			idToken:data.authorization['id_token'],
			password:newPassword
		}
		this.props.addPassword(this.props.user.id,requestData).then((response) => {
			this.props.hideModal()
			const notificationMessage='email and password login to your account'
		 	this.props.showNotification(notificationMessage,'Added','default')
		})
			.catch(error => {
				this.props.hideModal()
				let errorMessage='Something went wrong. Unable to add email and password login.'
				if(errorMessages.accountErrors.addPassword[error.response.status]){
			 		errorMessage=`${errorMessages.accountErrors.addPassword[error.response.status]}`
				}
				this.props.showNotification(errorMessage,'Error','destroy')
			})



	}



	render() {
		const {signinMethods}=this.props 
		let hasGoogle=false
		if(signinMethods && signinMethods.google){
			hasGoogle=true
		}



		return (
			<div className='addPassword'>
				{hasGoogle &&
					<div className='addPassword-explainText'>
						Add a password to your Plickers account so you can always sign in with email and password, even if you lose access to your Google account.
						After adding a password, you will still be able to access Plickers via the Google Sign-in button.
					</div>
				}
				{!hasGoogle &&
					<div className='addPassword-explainText'>
						Add a password to your Plickers account so you can always sign in with email and password, even if you lose access to your Apple account.
						After adding a password, you will still be able to access Plickers via the Apple Sign-in button.
					</div>
				}

				{hasGoogle &&
					<AddPasswordToGoogleForm
						email={this.props.user.email}            
						responseGoogle={responseGoogle}
						addPassword={this.addPasswordToGoogle}
					/>
				}
				{!hasGoogle &&
					<AddPasswordToAppleForm
						email={this.props.user.email}            
						responseGoogle={responseGoogle}
						addPassword={this.addPasswordToApple}
					/>
				}

			</div>
		)
	}
}



export default connect(
	(state,ownProps) => ({
		user:state.user,
		idToken:state.modals.idToken,
		form:state.form.addPasswordForm,
		signinMethods:state.signinMethods,

	}),
	{addPassword,showNotification,hideModal}
)(AddPasswordContainer)